import { DexfSettingsEnvironmentEnum } from '@inter-ikea-kompis/enums';
import { ServiceException } from '@inter-ikea-kompis/exceptions';
import { LocaleUtility } from '@inter-ikea-kompis/utilities';
import ServiceFetch from '../../utilities/ServiceFetch.js';
import DexfSettingsTransformer from './DexfSettingsTransformer.js';
const DEXF_QA = 'https://api.dexf.qa.ikeadt.com';
const DEXF_PROD = 'https://api.dexf.ikea.com';
/**
 * This service is used for fetching setting configuration from DEXF.
 */
export default class DexfSettingsService {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.dexfApiKey DEXF API key.
     * @param options.environment ...
     */
    constructor(options) {
        this.dexfApiKey = options.dexfApiKey;
        this.endpoint = `${options.environment === DexfSettingsEnvironmentEnum.development ? DEXF_QA : DEXF_PROD}/setting/v1/data/apps/{appId}/retail-units/{retailUnit}/locales/{language}-{country}`;
    }
    /**
     * Fetches setting configuration assigned to an application in DEXF.
     *
     * @param dexfApplicationId ...
     * @param locale ...
     * @param filterSegment ...
     * @returns Promise.
     */
    async getApplicationSettings(dexfApplicationId, locale, filterSegment) {
        const { country, language } = LocaleUtility.getCountryAndLanguage(locale);
        if (!country || !language) {
            throw new ServiceException('Country or language is not defined. Format locale correctly, e.g. en-GB');
        }
        const url = `${this.endpoint}${filterSegment ? `?filter.segment=${filterSegment}` : ''}`
            .replace('{appId}', dexfApplicationId)
            .replace('{retailUnit}', country.toUpperCase())
            .replace('{language}', language)
            .replace('{country}', country.toUpperCase());
        const response = await ServiceFetch.json(url, {
            credentials: 'same-origin',
            headers: {
                'dexf-api-key': this.dexfApiKey
            }
        });
        const transformer = new DexfSettingsTransformer({ locale });
        const transformedResponse = transformer.transform(response);
        return transformedResponse;
    }
}
//# sourceMappingURL=DexfSettingsService.js.map